export default __webpack_public_path__ + "static/media/Set3_4-min2.6d6dc734.png";